import React, { Component } from "react";
import fetchData from "../util/forms/basicFetch";
import LoadAwareFormLayout from "../util/forms/components/LoadAwareFormLayout";
import PropTypes from "prop-types";
import { withRouterUtilities } from "../util/withRouterUtilities";
import { withDataMapping } from "../util/hocs/withDataMapping";

class DataContainer extends Component {
  componentDidMount() {
    fetchData(this, false);
  }

  render() {
    const childrenWithProps = React.Children.map(this.props.children, (child) =>
      React.cloneElement(child, {
        data: this.props.data,
        fetchData,
      })
    );

    const loadingState = this.props.loading ? "loading" : "hide";

    return (
      <LoadAwareFormLayout
        id={this.props.id}
        wrapperClassName={this.props.className}
        childrenWithProps={childrenWithProps}
        loadingState={loadingState}
        loading={this.props.loading}
      />
    );
  }
}

DataContainer.propTypes = {
  loadEndpoint: PropTypes.string.isRequired,
  autoLoad: PropTypes.bool,
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export const RoutedDataContainer = withRouterUtilities(DataContainer);
export default withDataMapping(RoutedDataContainer);
